import { CLIP_LIBRARY } from '../configs/media/clipLibrary';
function isActiveClip(clip) {
    return clip.status === 'active';
}
// Library navigation. Inactive (unavailable on Twitch) clips are omitted.
export function getAllClips() {
    return CLIP_LIBRARY.clips.filter(isActiveClip);
}
// Filtering functions
export function getClipsByGame(gameId) {
    return getAllClips().filter((clip) => clip.gameId === gameId);
}
//# sourceMappingURL=getClips.js.map